import { FilterSelect, SearchInput, SortIcon } from "@marketplace/shared/ui";
import { getRouteApi } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import type { TransactionHistorySearchSchema } from "@/routes/transaction-history";

import { useTransactionHistorySortByOptions } from "../../hooks/use-transaction-history-sort-by-options";

const route = getRouteApi("/transaction-history/");

export const TransactionHistoryFilter = () => {
  const { q, sort } = route.useSearch();
  const navigate = route.useNavigate();
  const [search, setSearch] = useState(q ?? "");
  const { t } = useTranslation("order", {
    keyPrefix: "transactionHistoryPage"
  });
  const { t: tCommon } = useTranslation("common");
  const sortByOptions = useTransactionHistorySortByOptions();

  const handleSearch = (value: string) => {
    setSearch(value);
  };

  const handleSortByChange = (
    value: TransactionHistorySearchSchema["sort"]
  ) => {
    navigate({
      search: (prev) => ({
        ...prev,
        q: search,
        page: 1,
        sort: value
      })
    });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate({
        search: (prev) => ({
          ...prev,
          q: search,
          page: 1
        })
      });
    }, 300);

    return () => clearTimeout(timeout);
  }, [search, navigate]);

  return (
    <div className="flex justify-between items-center mb-6">
      <div>
        <SearchInput
          className="lg:w-[634px]"
          placeholder={t("searchPlaceholder")}
          value={search}
          onChange={handleSearch}
        />
      </div>
      <div className="flex gap-x-[14px]">
        <FilterSelect
          value={sort}
          label={tCommon("sortBy")}
          options={sortByOptions}
          width={179}
          icon={<SortIcon />}
          dropdownPosition="bottom-end"
          onChange={(v) =>
            handleSortByChange(v as TransactionHistorySearchSchema["sort"])
          }
        />
      </div>
    </div>
  );
};
